<po-page-default
  p-title="Relatório - Saídas Fazendas">
  <po-container class="po-sm-12 po-md-12 po-lg-12">
    <form #formFiltros = "ngForm">
      <po-datepicker class="po-sm-2 po-md-2 po-lg-2"
        name="emissaode"
        p-required="true"
        p-label="Emissão De"
        [p-iso-format]="formatBasic"
        [(ngModel)]="filtrosPrincipal.DEMISSAODE">
      </po-datepicker>
      <po-datepicker class="po-sm-2 po-md-2 po-lg-2"
        name="emissaoate"
        p-required="true"
        p-label="Emissão Até"
        [p-iso-format]="formatBasic"
        [(ngModel)]="filtrosPrincipal.DEMISSAOATE">
      </po-datepicker>
    </form>
    <po-button class="po-sm-1 po-md-1 po-lg-1 po-mt-3"
      p-label="Gerar Excel"
      p-icon="po-icon-doc-xls"
      p-kind="primary"
      [p-disabled]="formFiltros.invalid"
      (p-click)="loadDados()">
    </po-button>
  </po-container>
</po-page-default>
